import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

const Hero = () => {
  return (
    <div className="hero my-6" id="about">
      <div className="hero-content flex-col lg:flex-row-reverse">
        <img
          src="https://i.ibb.co/7Y370zd/my-cover2.jpg"
          className="sm:max-w-md rounded-lg shadow-2xl"
        />
        <ScrollAnimation animateIn="fadeIn">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl font-bold">Shahinul Islam</h1>
            <h4 className="text-2xl font-bold">Frontend Developer</h4>
            <p className="py-6">
              I like to craft solid and scalable frontend products with great
              user experiences.
            </p>
            <a
              href="https://drive.google.com/file/d/1MKgXhAKbV9TJJ59J1x4Vk75ZW2sMX_hV/view"
              download="https://drive.google.com/file/d/1MKgXhAKbV9TJJ59J1x4Vk75ZW2sMX_hV/view"
              target="_blank"
              className="btn btn-secondary"
            >
              Resume
            </a>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Hero;
